import * as React from 'react'

import { Alert, Box, Icon, RadioButton, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { usePricingContext } from 'modules/onboarding/components/Pricing/PricingContext'
import { VariantsEnum } from 'modules/onboarding/lib/pricing/plans/types'
import { BUSINESS_VARIANT, ENTERPRISE_VARIANT } from 'modules/onboarding/lib/pricing/plans/utils'

type Props = {
  variant: VariantsEnum
  features: string[]
  toggle: (variant: VariantsEnum) => void
  isSelected: boolean
  isCore: boolean
}

const ToggleCard = ({ variant, features, isSelected, toggle, isCore }: Props) => {
  const { allPlans } = usePricingContext()
  const [isHover, setIsHover] = React.useState(false)
  const hoverColor = isHover ? 'grey800' : 'grey600'
  const borderColor = isSelected ? 'viridian1000' : hoverColor
  const isCoreEnterpriseSelected = allPlans.corePlans.some(
    (plan) => plan.activeVariantType === ENTERPRISE_VARIANT
  )
  const showAlert = !isCore && !isCoreEnterpriseSelected && variant === ENTERPRISE_VARIANT

  return (
    <Box
      background={isSelected ? 'viridian100' : 'grey000White'}
      cursor="pointer"
      onMouseEnter={() => {
        setIsHover(true)
      }}
      onMouseLeave={() => {
        setIsHover(false)
      }}
      onClick={() => {
        toggle(variant)
      }}
      borderRadius={{ all: 'abs012' }}
      border={{
        all: {
          color: borderColor,
          style: 'solid',
          width: 's2',
        },
      }}
      padding="s24"
      gap="s8"
      style={{ flex: '1' }}
    >
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text size="300" weight="semibold" color="grey1000">
          {variant}
        </Text>
        <RadioButton
          checked={isSelected}
          onChange={() => {
            toggle(variant)
          }}
          value={variant}
        />
      </Box>
      <Text size="100" weight="medium" color="grey1000">
        {variant === BUSINESS_VARIANT
          ? i18n.t('pricing_plans.custom_bundles.features.business')
          : i18n.t('pricing_plans.custom_bundles.features.enterprise')}
        :
      </Text>
      <Box gap="s8">
        {features.map((feature, index) => (
          <Box key={`${feature}-${index}`} gap="s4" flexDirection="row">
            <Box>
              <Icon.Medium icon="check" color="viridian1000" />
            </Box>
            <Box alignSelf="center">
              <Text size="200" color="grey800">
                {feature}
              </Text>
            </Box>
          </Box>
        ))}
        {showAlert && (
          <Alert color="warning">
            <Text size="200">
              {i18n.t('pricing_plans.custom_bundles.enterprise_required.alert')}
            </Text>
          </Alert>
        )}
      </Box>
    </Box>
  )
}

export default ToggleCard
